module.exports = __webpack_public_path__ + "img/eductorenviro_parked.3bb25125.svg";